(() => {
  'use strict';

  const DESKTOP_QUERY = '(min-width: 750px)';

  function initProductTabs(root) {
    if (!root || root.dataset.gpTabsInitialized === 'true') {
      return;
    }

    root.dataset.gpTabsInitialized = 'true';

    const tabs = Array.from(root.querySelectorAll('[data-gp-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-gp-panel]'));

    if (!tabs.length || !panels.length) {
      return;
    }

    const desktopMedia = window.matchMedia(DESKTOP_QUERY);

    /**
     * Werkt aria-selected, tabindex en actieve styling bij.
     */
    function setTabState(name, moveFocus = false) {
      tabs.forEach((tab) => {
        const isActive = tab.dataset.gpTab === name;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;

        if (isActive && moveFocus) {
          tab.focus();
        }
      });
    }

    /**
     * Activeert één desktop-tab en sluit de overige panels.
     */
    function activateDesktopTab(name, moveFocus = false) {
      setTabState(name, moveFocus);

      panels.forEach((panel) => {
        panel.open = panel.dataset.gpPanel === name;
      });
    }

    /**
     * Klikken op desktop-tabs.
     */
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        activateDesktopTab(tab.dataset.gpTab);
      });

      /**
       * Keyboard navigation voor toegankelijkheid:
       * pijltjestoetsen, Home en End.
       */
      tab.addEventListener('keydown', (event) => {
        if (!desktopMedia.matches) {
          return;
        }

        let nextIndex = null;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIndex = (index + 1) % tabs.length;
            break;

          case 'ArrowLeft':
          case 'ArrowUp':
            nextIndex = (index - 1 + tabs.length) % tabs.length;
            break;

          case 'Home':
            nextIndex = 0;
            break;

          case 'End':
            nextIndex = tabs.length - 1;
            break;

          default:
            return;
        }

        event.preventDefault();

        activateDesktopTab(
          tabs[nextIndex].dataset.gpTab,
          true
        );
      });
    });

    /**
     * Op mobiel werkt ieder panel als native <details>-accordeon.
     * Bij openen sluiten we de andere onderdelen.
     */
    panels.forEach((panel) => {
      panel.addEventListener('toggle', () => {
        if (!panel.open) {
          return;
        }

        const panelName = panel.dataset.gpPanel;

        setTabState(panelName);

        if (!desktopMedia.matches) {
          panels.forEach((otherPanel) => {
            if (otherPanel !== panel) {
              otherPanel.open = false;
            }
          });
        }
      });
    });

    /**
     * Synchronisatie wanneer schermbreedte verandert.
     */
    function syncLayout() {
      if (!desktopMedia.matches) {
        return;
      }

      const activeTab =
        tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0];

      activateDesktopTab(activeTab.dataset.gpTab);
    }

    if (typeof desktopMedia.addEventListener === 'function') {
      desktopMedia.addEventListener('change', syncLayout);
    } else {
      desktopMedia.addListener(syncLayout);
    }

    syncLayout();
  }

  /**
   * Initialiseert alle tabblokken op de pagina.
   */
  function initAllProductTabs(scope = document) {
    scope.querySelectorAll('[data-gp-tabs]').forEach(initProductTabs);
  }

  /**
   * Normale paginalaad.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllProductTabs();
    });
  } else {
    initAllProductTabs();
  }

  /**
   * Ondersteuning voor Shopify Theme Editor.
   */
  document.addEventListener('shopify:section:load', (event) => {
    initAllProductTabs(event.target);
  });
})();